<template>
  <v-data-table
    :headers="visibleHeaders"
    :items="companies"
    :items-per-page-options="CONST.ROWS_PER_PAGE_ITEMS">
    <template #[`item.locationAddress`]="{ item }">
      {{ getLocationBasicAddressInfo(getRawItem(item).location || {}) }}
    </template>
    <template v-if="canUpdate || canDelete" #[`item.actions`]="{ item }">
      <div class="action-cell">
        <v-btn v-if="canUpdate" icon size="small" variant="text" class="table-action-button" aria-label="Editar" @click="editItem(getRawItem(item))">
          <v-icon>edit</v-icon>
        </v-btn>
        <v-btn v-if="canDelete" icon size="small" variant="text" class="table-action-button table-action-danger" aria-label="Eliminar" @click="deleteItem(getRawItem(item))">
          <v-icon>delete</v-icon>
        </v-btn>
      </div>
    </template>
    <template #no-data>
      <span>{{ CONST.NO_RESULTS_CHECK_FILTERS }}</span>
      <v-btn color="primary" class="ml-3" @click="initialize">{{ CONST.REFRESH }}</v-btn>
    </template>
  </v-data-table>
</template>
<script>
import CONST from '../../services/common/Constants.js'
import { mapGetters } from 'vuex'
export default {
  name: 'CompanyTable',
  data: () => ({
    CONST: {},
    itemType: 'ENTIDAD COMERCIAL',
    headers: [
      {title: 'Nombre', align: 'center', key: 'name'},
      {title: 'CUIT', align: 'center', key: 'cuit', sortable: false},
      {title: 'Lugar', align: 'center', key: 'location.name'},
      {title: 'Direccion', align: 'center', key: 'locationAddress', sortable: false},
      {title: 'Telefono', align: 'center', key: 'phone', sortable: false},
      {title: 'Mail', align: 'center', key: 'mail', sortable: false},
      {title: 'Tipo de Responsable', align: 'center', key: 'responsibleType.description'},
      {title: 'Acciones', align: 'center', key: 'actions', sortable: false}
    ],
    companies: []
  }),

  computed: {
    ...mapGetters(['isRefreshTableRequired']),
    ...mapGetters('authModule', ['hasPermission']),
    canUpdate () { return this.hasPermission('catalog.companies.update') },
    canDelete () { return this.hasPermission('catalog.companies.delete') },
    visibleHeaders () {
      return this.canUpdate || this.canDelete ? this.headers : this.headers.filter(header => header.key !== 'actions')
    },
    ...mapGetters('companyModule', ['getFilteredCompanies'])
  },

  created () {
    this.CONST = CONST
    this.initialize()
  },

  watch: {
    getFilteredCompanies: function () {
      this.companies = this.$store.getters['companyModule/getFilteredCompanies']
    },
    isRefreshTableRequired: function (newValue, oldValue) {
      if (newValue === true && oldValue === false) {
        this.initialize()
      }
    }
  },

  methods: {
    initialize () {
      this.$store.dispatch('companyModule/getCompanies').then(() => {
        this.companies = this.$store.getters['companyModule/getCompanies']
      })
    },

    getRawItem (item) {
      return item.raw || item
    },

    getLocationBasicAddressInfo (location) {
      const address = location.address || ''
      const city = location.city || ''
      return city ? `${address} (${city})` : address
    },

    editItem (item) {
      this.$store.dispatch('companyModule/setSelectedItem', Object.assign({}, item))
      this.$store.dispatch('companyModule/setDialogActived', true)
    },

    deleteItem (item) {
      confirm(`Estas seguro de querer eliminar: ${item.name}?`) && this.$store.dispatch('companyModule/removeCompany', item.id).then(() => {
        this.initialize()
      }).catch(error => console.log('There was an error trying to delete Company.' + error))
    }
  }
}
</script>
